(function () {
  function initArchive(section) {
    if (!section || section.dataset.oktpReady) return;
    section.dataset.oktpReady = 'true';

    var grid = section.querySelector('[data-oktp-grid]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-oktp-artwork]'));
    var prev = section.querySelector('[data-oktp-prev]');
    var next = section.querySelector('[data-oktp-next]');
    var dots = section.querySelector('[data-oktp-dots]');
    var range = section.querySelector('[data-oktp-range]');
    var start = section.querySelector('[data-oktp-start]');
    var pageSize = 16;
    var page = 0;
    var ascending = false;

    if (!grid || !cards.length) return;

    function orderedCards() {
      return cards.slice().sort(function (a, b) {
        var an = parseInt(a.getAttribute('data-number'), 10) || 0;
        var bn = parseInt(b.getAttribute('data-number'), 10) || 0;
        return ascending ? an - bn : bn - an;
      });
    }

    function pagesCount() {
      return Math.ceil(cards.length / pageSize);
    }

    function makeDots() {
      dots.innerHTML = '';
      var total = pagesCount();
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Show group ' + (i + 1));
        dot.dataset.page = i;
        dot.style.cssText = 'width:9px;height:9px;border:0;border-radius:50%;padding:0;cursor:pointer;background:var(--oktp-rule);';
        dot.addEventListener('click', function () {
          page = parseInt(this.dataset.page, 10);
          render(true);
        });
        dots.appendChild(dot);
      }
    }

    function render(scrollIntoView) {
      var ordered = orderedCards();
      var totalPages = pagesCount();
      if (page < 0) page = 0;
      if (page > totalPages - 1) page = totalPages - 1;

      cards.forEach(function (card) { card.hidden = true; });
      ordered.forEach(function (card) { grid.appendChild(card); });

      var from = page * pageSize;
      var current = ordered.slice(from, from + pageSize);
      current.forEach(function (card) { card.hidden = false; });

      prev.disabled = page === 0;
      next.disabled = page >= totalPages - 1;
      prev.style.opacity = prev.disabled ? '.3' : '1';
      next.style.opacity = next.disabled ? '.3' : '1';
      prev.style.cursor = prev.disabled ? 'default' : 'pointer';
      next.style.cursor = next.disabled ? 'default' : 'pointer';

      var nums = current.map(function (card) { return parseInt(card.getAttribute('data-number'), 10); });
      if (nums.length) {
        var low = Math.min.apply(Math, nums);
        var high = Math.max.apply(Math, nums);
        range.textContent = '#' + low + '–#' + high + ' · ' + cards.length + ' total';
      }

      Array.prototype.forEach.call(dots.children, function (dot, index) {
        dot.style.background = index === page ? 'var(--oktp-ink)' : 'var(--oktp-rule)';
        dot.style.transform = index === page ? 'scale(1.35)' : 'scale(1)';
      });

      start.textContent = ascending ? 'Back to newest →' : 'Start at the beginning →';

      if (scrollIntoView) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    prev.addEventListener('click', function () {
      if (page > 0) { page -= 1; render(true); }
    });
    next.addEventListener('click', function () {
      if (page < pagesCount() - 1) { page += 1; render(true); }
    });
    start.addEventListener('click', function () {
      ascending = !ascending;
      page = 0;
      makeDots();
      render(true);
    });

    makeDots();
    render(false);
  }

  function initAll() {
    document.querySelectorAll('[data-oktp-archive]').forEach(initArchive);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();